import SpaceBookingRulesModel from '@/shared/models/space/SpaceBookingRulesModel';
class SpaceBookingRulesForm extends SpaceBookingRulesModel {
    hideAttributes() {
        return ['id'];
    }
}
export default SpaceBookingRulesForm;
